import { gql } from '@apollo/client'
import { PERMISSIONS_FRAGMENT } from 'graphql/securityProfiles/queries'

export const USER_DATA_FRAGMENT = gql`
  fragment USER_DATA on User {
    id
    companyId
    lastName
    firstName
    displayName
    roles
    username
    company {
      id
      currency
      licences
      logoUrl
    }
    positions {
      id
      description
    }
    securityGroups {
      id
      name
      active
      businessRules {
        users {
          userOrPositionId
          securityProfileId
        }
        views {
          canView
          riskTemplateId
        }
      }
    }
    permissionsFromSecurityGroups {
      ...PERMISSIONS
    }
    controlledIds
    userAndPositionIds
  }
  ${PERMISSIONS_FRAGMENT}
`

export const AUTH_SIGN_IN_MUTATION = gql`
  mutation AUTH_SIGN_IN_MUTATION($email: String!, $domain: String!, $password: String!) {
    authSignIn(email: $email, domain: $domain, password: $password) {
      ok
      data {
        accessToken
        user {
          ...USER_DATA
        }
        twoFactorRequired
        twoFactorToken
        twoFactorSetupRequired
        twoFactorSetupToken
      }
    }
  }
  ${USER_DATA_FRAGMENT}
`

export const AUTH_RESET_PASSWORD_MUTATION = gql`
  mutation AUTH_RESET_PASSWORD_MUTATION($email: String!, $domain: String!) {
    authResetPassword(email: $email, domain: $domain) {
      ok
    }
  }
`

export const AUTH_SET_NEW_PASSWORD_MUTATION = gql`
  mutation AUTH_SET_NEW_PASSWORD_MUTATION($email: String!, $domain: String!, $token: String!, $password: String!) {
    authSetNewPassword(email: $email, domain: $domain, token: $token, password: $password) {
      ok
      data {
        accessToken
        user {
          ...USER_DATA
        }
        twoFactorRequired
        twoFactorToken
      }
    }
  }
  ${USER_DATA_FRAGMENT}
`

export const MICROSOFT_SIGN_IN_MUTATION = gql`
  mutation MICROSOFT_SIGN_IN_MUTATION($companyId: ID!, $token: String!) {
    authExchangeMicrosoftToken(companyId: $companyId, token: $token) {
      ok
      data {
        accessToken
        user {
          ...USER_DATA
        }
      }
    }
  }
  ${USER_DATA_FRAGMENT}
`

export const MICROSOFT_GET_COMPANIES = gql`
  mutation MICROSOFT_GET_COMPANIES($token: String!) {
    authMicrosoftTokenGetAvailableCompanies(token: $token) {
      data {
        id
        name
        domainName
      }
    }
  }
`

export const AUTH_REFRESH_TOKEN_MUTATION = gql`
  mutation AUTH_REFRESH_TOKEN_MUTATION {
    authRefreshToken {
      ok
      data {
        accessToken
      }
    }
  }
`

export const AUTH_SIGN_OUT_MUTATION = gql`
  mutation AUTH_SIGN_OUT_MUTATION {
    authSignOut {
      ok
      message
    }
  }
`

export const AUTH_SIGN_OUT_ALL_MUTATION = gql`
  mutation AUTH_SIGN_OUT_ALL_MUTATION {
    authSignOutAll {
      ok
      message
    }
  }
`

export const AUTH_REVOKE_SESSION_MUTATION = gql`
  mutation AUTH_REVOKE_SESSION_MUTATION($sessionId: ID!) {
    authRevokeSession(sessionId: $sessionId) {
      ok
      message
    }
  }
`

export const AUTH_EXCHANGE_CAPTCHA_TOKEN = gql`
  mutation AUTH_EXCHANGE_CAPTCHA_TOKEN($token: String!, $domain: String) {
    authExchangeCaptchaToken(token: $token, domain: $domain) {
      ok
      data {
        accessToken
        refreshToken
      }
    }
  }
`
